import { useContext } from "react";

import { ErrorHandlerContext } from "./ErrorHandlerContext.ts";
import type { ErrorHandlerContextType } from "./types.ts";

export function useErrorHandler(): ErrorHandlerContextType {
  const ctx = useContext(ErrorHandlerContext);

  if (!ctx) {
    throw new Error(
      "useErrorHandler must be used within an ErrorHandlerProvider",
    );
  }

  return ctx;
}
